import { handleComponentError } from "../decorators/handleComponentError"
import { LinkInterface } from "../types/link.interface"
import { Text } from "./text"

export class Link extends Text {
    override props!: LinkInterface

    constructor(props: LinkInterface) {
        super(props)
    }

    private setUrl(url?: string): void {
        if (url) {
            ;(this.element as HTMLAnchorElement).href = url
        }
    }

    protected override setHoverColor(hoverColor?: string): void {
        if (hoverColor) {
            this.element!.style.setProperty("--link-hover-color", hoverColor)
        }
    }

    protected setDecorationHoverColor(decorationHoverColor?: string): void {
        if (decorationHoverColor) {
            this.element!.style.setProperty(
                "--link-decoration-hover-color",
                decorationHoverColor
            )
        }
    }

    protected setColor(color?: string) {
        if (color) {
            this.element!.style.setProperty("--link-color", color)
        }
    }

    @handleComponentError("Link")
    render() {
        this.setUrl(this.props.url)
        this.setHoverColor(this.props.hoverColor)
        this.setDecorationHoverColor(this.props.decorationHoverColor)
        super.render()
    }
}
